// クラシック版の調整（サブメニュー）のボタンの定義（段階 C の2 の 5c-3。2026-10-25 に chibi.js と画面ファイル legacy.js・gen1b.js から描き直した。動きは前と同じ）。
// 反転・移動・拡大・縮小・線を太く・細く。拡大して見る（btnSubZoom）は 5d。系統（SCREEN）ごとの違い:
//   反転: エンジンのまま・第1世代 a・第2世代（ボタンの状態の向きに反転）／第1世代 b（前の gen1b.js。反転できるカテゴリはそのカテゴリだけ今の向きの反対へ、それ以外はキャラ全体。
//         CHOCO は REVERSE_SIMPLE で状態の向き、profile・run は REVERSE_ALL_ALIGN で基準のパーツの反対へ全体をそろえる）
//   移動: エンジンのまま（HTML のサブメニュー #chaDivSubMenu を出し入れ）／系統のある画面（前の legacy.js。キャラの上の矢印を出し入れ）
// jakigan の反転は REVERSE_TOGGLE の版（前の画面ファイル jakigan.js。2026-10-26 の 7f で TS に）。
// キャラの SVG の選び方・属性は前と同じく d3 の選択（chibi.svgMake）で
import { chibi, common } from './engine.js';
import { setStyle } from './dom.js';
import { screen } from './colors.js';
import * as fx from './fx.js';

type Engine = Record<string, any>;
const E = (): Engine => chibi() as unknown as Engine;
const C = (): Record<string, any> => common() as unknown as Record<string, any>;
const button = (): { setMask(sel: unknown, valid: boolean): void; setStatus(sel: unknown, def: unknown, status?: number): void } =>
  (window as unknown as { charat: { button: { setMask(sel: unknown, valid: boolean): void; setStatus(sel: unknown, def: unknown, status?: number): void } } }).charat.button;
const mask = (name: string, valid: boolean): void => button().setMask(E().svgMakeMenu.select('#' + E()[name].ID + '>image'), valid);

/** ボタンの定義を作る */
export function makeSubButtons(): Record<string, unknown> {
  const e = E();
  const P = e.PATH_IMG, SUB = e.ATTR_EDITSUBBUTTON;
  const scr = screen();
  const btns: Record<string, any> = {};
  const icon = (name: string): string[] => [P + 'icon_left/' + name + '.svg', P + 'icon_left/' + name + '.svg'];

  // 反転
  if (scr === 'gen1b') {
    const simple = (): boolean => E().config('REVERSE_SIMPLE', false);
    btns.btnSubReverse = {
      ID: SUB + 'Reverse',
      STATUS: 0,
      FILE: icon('reverse'),
      CLICK: () => {
        const en = E();
        if (simple() ? en.selCategory.IS_REV != 0 : en.selCategory.IS_REV > 0) en.btnSubReverse.EXEC();
      },
      SETSTATUS: (a: number) => {
        const en = E();
        en.btnSubReverse.STATUS = a;
        button().setStatus(en.svgMakeMenu.select('#' + en.btnSubReverse.NAME), en.btnSubReverse, a);
        en.btnSubReverse.EXEC();
      },
      RESET: (valid: boolean) => {
        E().btnSubReverse.SETSTATUS(valid ? 1 : 0);
      },
      ENABLED: (valid: boolean) => mask('btnSubReverse', valid),
      EXEC: () => {
        const en = E(), c = C();
        if (simple()) {
          c.reverseG(en.svgMake, en.selCategory, en.ATTR_LAYER, en.btnSubReverse.STATUS != 0, en.scMake.x, en.scMake.y, en.SIZE_CHARAT_IMAGE);
        } else if (en.selCategory.IS_REV == 1) {
          const isRev = c.getReverseG(en.selCategory, en.ATTR_LAYER);
          c.reverseG(en.svgMake, en.selCategory, en.ATTR_LAYER, !isRev, en.scMake.x, en.scMake.y, en.SIZE_CHARAT_IMAGE);
        } else if (en.config('REVERSE_ALL_ALIGN', false)) {
          // 全体: profile・run は基準のパーツ（PARTS_REV）の向きの反対へ全カテゴリをそろえる
          const isRev = c.getReverseG(en.allCategory[en.PARTS_REV], en.ATTR_LAYER);
          en.reverseAll(!isRev, [en.PARTS_CHARA]);
        } else {
          // 全体: front 型の reverseAll は引数が除くレイヤーの並びだけ（それぞれ今の向きの反対へ。load.ts の makeReverseAll）
          en.reverseAll([en.PARTS_CHARA]);
        }
      },
    };
  } else if (scr === 'gen2' && e.config('REVERSE_TOGGLE', false)) {
    // jakigan（REVERSE_TOGGLE。前の画面ファイル jakigan.js）: 今の向きの反対へ。反転できる 1 のカテゴリ（背景）はそのカテゴリだけ、
    // それ以外（2）は顔（PARTS_REV）の向きを見てキャラ全体（キャラの一覧のカテゴリは除く）。パーツを替えても戻さないよう、ページで RESET_REVERSE_ON_PARTS_CHANGE: false
    btns.btnSubReverse = {
      ID: SUB + 'Reverse',
      STATUS: 0,
      FILE: icon('reverse'),
      CLICK: () => {
        if (E().selCategory.IS_REV > 0) E().btnSubReverse.EXEC();
      },
      SETSTATUS: (status: number, isFast?: boolean) => {
        const en = E();
        en.btnSubReverse.STATUS = status;
        button().setStatus(en.svgMakeMenu.select('#' + en.btnSubReverse.NAME), en.btnSubReverse, status);
        en.btnSubReverse.EXEC(isFast);
      },
      RESET: (valid: boolean) => {
        E().btnSubReverse.SETSTATUS(valid ? 1 : 0, true);
      },
      ENABLED: (valid: boolean) => mask('btnSubReverse', valid),
      EXEC: (isFast?: boolean) => {
        const en = E(), c = C();
        const wt = isFast == true ? 0 : 100;
        if (en.selCategory.IS_REV == 1) {
          const isRev = c.getReverseG(en.selCategory, en.ATTR_LAYER);
          c.reverseG(en.svgMake, en.selCategory, en.ATTR_LAYER, !isRev, en.scMake.x, en.scMake.y, en.SIZE_CHARAT_IMAGE, 0, wt);
        } else {
          const isRev = c.getReverseG(en.allCategory[en.PARTS_REV], en.ATTR_LAYER);
          en.reverseAll(!isRev, [en.PARTS_CHARA]);
        }
      },
    };
  } else {
    btns.btnSubReverse = {
      ID: SUB + 'Reverse',
      STATUS: 0,
      FILE: icon('reverse'),
      CLICK: () => {
        if (E().selCategory.IS_REV != 0) E().btnSubReverse.EXEC();
      },
      // 注意: NAME は無いので setStatus は "#undefined" を見る（前のまま）
      SETSTATUS: (status: number, isFast?: boolean) => {
        const en = E();
        en.btnSubReverse.STATUS = status;
        button().setStatus(en.svgMakeMenu.select('#' + en.btnSubReverse.NAME), en.btnSubReverse, status);
        en.btnSubReverse.EXEC(isFast);
      },
      RESET: (valid: boolean) => {
        E().btnSubReverse.SETSTATUS(valid ? 1 : 0, true);
      },
      ENABLED: (valid: boolean) => mask('btnSubReverse', valid),
      EXEC: (isFast?: boolean) => {
        const en = E();
        C().reverseG(en.svgMake, en.selCategory, en.ATTR_LAYER, en.btnSubReverse.STATUS != 0, en.scMake.x, en.scMake.y, en.SIZE_CHARAT_IMAGE, 0, isFast == true ? 0 : 100);
      },
    };
  }

  // 移動
  if (scr === 'new') {
    // エンジンのまま: STATUS が 1 のあいだ移動のサブメニュー（#chaDivSubMenu）を出す。_VALID は選んでいるカテゴリが動かせるか
    btns.btnSubMove = {
      ID: SUB + 'Move',
      MODE: C().makeMenuButtonModeSW,
      STATUS: 0,
      _VALID: false,
      VALID: () => E().btnSubMove._VALID,
      FILE: icon('move'),
      // 注意: VALID を () なしで見ているので、いつも真（前のまま）
      CLICK: () => {
        const en = E();
        if (en.btnSubMove.VALID && en.selCategory.IS_MOVE != 0) en.btnSubMove.EXEC();
      },
      SETSTATUS: (status: number) => {
        E().btnSubMove.STATUS = status;
        E().btnSubMove.EXEC();
      },
      RESET: () => {
        E().btnSubMove.SETSTATUS(0);
      },
      // カテゴリを選んだとき。注意: ボタンの位置と色（#esubbtnMove を translate(25,0)・濃い灰色）は valid に関係なく毎回同じにする（前のまま）
      ENABLED: (valid: boolean) => {
        const en = E();
        en.btnSubMove.RESET();
        mask('btnSubMove', valid);
        en.btnSubMove._VALID = valid;
        const g = document.querySelector('#esubbtnMove');
        if (g) {
          g.setAttribute('transform', 'translate(25,0)');
          const r = Array.from(g.children).find((c) => c.tagName.toLowerCase() === 'rect');
          if (r) fx.setCssEl(r, 'fill', 'rgb(60,60,60)');
        }
      },
      ON: () => {
        E().btnSubMove.SETSTATUS(1);
      },
      OFF: () => {
        E().btnSubMove.SETSTATUS(0);
      },
      EXEC: () => {
        fx.setCss(E().DIV_F_SUBMENU, 'display', E().btnSubMove.STATUS == 0 ? 'none' : 'block');
        C().updateLrselectctnStyle();
      },
    };
  } else {
    // 系統のある画面: キャラの上の移動の矢印（g.movebutton）を出し入れ
    btns.btnSubMove = {
      ID: SUB + 'Move',
      STATUS: 0,
      FILE: icon('move'),
      CLICK: () => {
        if (E().selCategory.IS_MOVE != 0) E().btnSubMove.EXEC();
      },
      SETSTATUS: (status: number) => {
        E().btnSubMove.STATUS = status;
        E().btnSubMove.EXEC();
      },
      RESET: () => {
        E().btnSubMove.SETSTATUS(0);
      },
      ENABLED: (valid: boolean) => {
        E().btnSubMove.RESET();
        mask('btnSubMove', valid);
      },
      ON: () => {
        E().btnSubMove.SETSTATUS(1);
      },
      OFF: () => {
        E().btnSubMove.SETSTATUS(0);
      },
      EXEC: () => {
        const en = E(), menu = en.svgMakeMenu.node() as Element | null;
        if (!menu) return;
        menu.querySelectorAll('g.' + en.ATTR_MOVEBUTTON).forEach((g) => setStyle(g, 'display', en.btnSubMove.STATUS == 0 ? 'none' : 'block'));
      },
    };
  }

  // 拡大・縮小（選んでいるカテゴリのパーツを 0.02 ずつ、最大 0.2）
  const zoom = (name: string, isZoom: boolean, file: string): unknown => ({
    ID: SUB + name,
    STATUS: 0,
    FILE: icon(file),
    SETSTATUS: (status: number) => {
      E()['btnSub' + name].STATUS = status;
    },
    CLICK: () => {
      if (E().selCategory.IS_ZOOM != 0) E()['btnSub' + name].EXEC();
    },
    RESET: () => {
      E()['btnSub' + name].SETSTATUS(0);
    },
    ENABLED: (valid: boolean) => {
      E()['btnSub' + name].RESET();
      mask('btnSub' + name, valid);
    },
    EXEC: () => {
      const en = E();
      C().zoomG(en.svgMake, en.selCategory, en.ATTR_LAYER, isZoom, en.SIZE_CHARAT_IMAGE, en.SIZE_CHARAT_IMAGE, en.SIZE_CHARAT_IMAGE, 0.02, 0.2);
    },
  });
  btns.btnSubExpand = zoom('Expand', true, 'plus');
  btns.btnSubContract = zoom('Contract', false, 'minus');

  // 線を太く・細く（STROKE_WIDTH。origin・mono）。全カテゴリの線を 1 段（SIZE_WMIN〜SIZE_WMAX）。
  // 太くの EXEC(aLayerName) はパーツを替えたときに呼ぶもので、そのカテゴリの線を今の太さにそろえるだけ
  // 注意: 今の太さ getValidStrokeWidth は属性の文字のことがある（++・-- で数になる。前のまま）
  const stroke = (name: string, thick: boolean): unknown => ({
    ID: SUB + name,
    STATUS: 0,
    FILE: icon(thick ? 'thick' : 'thin'),
    SETSTATUS: (aStatus: number) => {
      E()['btnSub' + name].STATUS = aStatus;
    },
    CLICK: () => {
      if (E().selCategory.IS_SWIDTH != 0) E()['btnSub' + name].EXEC();
    },
    RESET: () => {
      E()['btnSub' + name].SETSTATUS(0);
    },
    ENABLED: (aEnabled: boolean) => {
      E()['btnSub' + name].RESET();
      mask('btnSub' + name, aEnabled);
    },
    EXEC: (aLayerName?: string) => {
      const en = E();
      let exec = true;
      let width: any = en.getValidStrokeWidth();
      if (thick) {
        if (aLayerName == undefined && ++width > en.SIZE_WMAX) exec = false;
      } else if (--width < en.SIZE_WMIN) {
        exec = false;
      }
      if (!exec) return;
      for (const key in en.allCategory) {
        const cat = en.allCategory[key];
        if (thick && !(aLayerName == undefined || aLayerName === cat.LAYER[0])) continue;
        en.svgMake.select('#' + en.ATTR_LAYER + cat.LAYER[0]).attr('paramSW', width);
        C().setStrokeWidth(en.svgMake, cat, en.ATTR_LAYER, width);
      }
    },
  });
  btns.btnSubThick = stroke('Thick', true);
  btns.btnSubThin = stroke('Thin', false);
  return btns;
}
